import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=2ad40832&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports